import { toTitleCase } from "@/utils/text";

const RANDOM_ACTION_VERBS: string[] = [
  "nebulizing",
  "supernovaing",
  "stardancing",
  "moonwalking",
  "cometing",
  "asteroiding",
  "meteoring",
  "orbiting",
  "spiraling",
  "wandering",
  "galaxying",
  "pulsaring",
  "quasaring",
  "warping",
  "wormholing",
  "blackholing",
  "gravitating",
  "levitating",
  "teleporting",
  "beaming",
  "photoning",
  "radiating",
  "cosmosing",
  "universing",
  "celestializing",
  "stellarizing",
  "astralizing",
  "lunaring",
  "eclipsing",
  "solaring",
  "sunbursting",
  "stardusting",
  "moondancing",
  "skyrocketing",
  "astronauting",
  "satelliting",
  "telescoping",
  "spacecrafting",
  "voyagering",
  "exploring",
  "discovering",
  "venturing",
  "launching",
  "blastoffing",
  "zooming",
  "whooshing",
  "superspeeding",
  "lightspeeding",
  "hyperdriving",
  "warpdriving",
  "glowing",
  "illuminating",
  "shimmering",
  "twinkling",
  "glittering",
  "sparkling",
  "scintillating",
  "coruscating",
  "shining",
  "beaconing",
  "flaring",
  "blazing",
  "incandescenting",
  "luminescing",
  "phosphorescing",
  "bioluminescing",
  "expanding",
  "inflating",
  "bigbanging",
  "coalescing",
  "accreting",
  "fusing",
  "ionizing",
  "plasmaing",
  "energizing",
  "antimattering",
  "quantuming",
  "dimensioning",
  "multiverseing",
  "infinitying",
  "eternitying",
  "cosmicizing",
  "astounding",
  "marveling",
  "wonderstrucking",
  "awestrucking",
  "starstrucking",
  "spellbinding",
  "mesmerizing",
  "enchanting",
  "bedazzling",
  "starglazing",
  "moonglazing",
  "spacewalking",
  "floating",
  "drifting",
  "hovering",
  "soaring",
  "ascending",
  "transcending",
];

const RANDOM_ANIMALS: string[] = [
  "Alligator",
  "Ant",
  "Antelope",
  "Armadillo",
  "Baboon",
  "Badger",
  "Bat",
  "Bear",
  "Beaver",
  "Bee",
  "Bison",
  "Buffalo",
  "Butterfly",
  "Camel",
  "Cat",
  "Cheetah",
  "Chicken",
  "Chimpanzee",
  "Cobra",
  "Cow",
  "Coyote",
  "Crab",
  "Crocodile",
  "Deer",
  "Dog",
  "Dolphin",
  "Donkey",
  "Duck",
  "Eagle",
  "Elephant",
  "Elk",
  "Emu",
  "Falcon",
  "Ferret",
  "Fish",
  "Flamingo",
  "Fox",
  "Frog",
  "Gazelle",
  "Gecko",
  "Giraffe",
  "Goat",
  "Goose",
  "Gorilla",
  "Hamster",
  "Hawk",
  "Hedgehog",
  "Hippopotamus",
  "Horse",
  "Hyena",
  "Ibex",
  "Iguana",
  "Jackal",
  "Jaguar",
  "Jellyfish",
  "Kangaroo",
  "Koala",
  "Dragon",
  "Lemur",
  "Leopard",
  "Lion",
  "Lizard",
  "Lobster",
  "Macaw",
  "Manatee",
  "Meerkat",
  "Mink",
  "Mole",
  "Monkey",
  "Moose",
  "Mouse",
  "Mule",
  "Newt",
  "Nightingale",
  "Octopus",
  "Opossum",
  "Orangutan",
  "Orca",
  "Ostrich",
  "Otter",
  "Owl",
  "Ox",
  "Panda",
  "Panther",
  "Parrot",
  "Peacock",
  "Pelican",
  "Penguin",
  "Pig",
  "Pigeon",
  "Porcupine",
  "Porpoise",
  "Quail",
  "Rabbit",
  "Raccoon",
  "Rat",
  "Raven",
  "Reindeer",
  "Rhinoceros",
  "Seal",
];

export function getRandomActionVerb({
  isTitleCase = true,
  includeEllipsis = true,
}: { isTitleCase?: boolean; includeEllipsis?: boolean } = {}): string {
  let verb = RANDOM_ACTION_VERBS[Math.floor(Math.random() * RANDOM_ACTION_VERBS.length)];

  if (isTitleCase) {
    verb = toTitleCase(verb);
  }

  if (includeEllipsis) {
    verb = `${verb}...`;
  }

  return verb;
}

/**
 * Get a random animal
 * @returns A random animal
 */
export function getRandomAnimal(isTitleCase: boolean = true): string {
  let animal = RANDOM_ANIMALS[Math.floor(Math.random() * RANDOM_ANIMALS.length)];

  if (isTitleCase) {
    animal = toTitleCase(animal);
  }

  return animal;
}
